import { WorkflowList } from "@/app/components/workflows/WorkflowList";

export default function WorkflowsPage() {
    return <WorkflowList />;
}
